// extracted by mini-css-extract-plugin
export default {"container":"verticalSpaceContainer_container__nPSqz"};